"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ToggleButtons = require("./ToggleButtons.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * DEPRECATED - ToggleButton component
 */
// intentionally left as a functional component
var ToggleButtons = function ToggleButtons(_ref) {
  var buttonLabel1 = _ref.buttonLabel1,
      buttonLabel2 = _ref.buttonLabel2,
      buttonValue1 = _ref.buttonValue1,
      buttonValue2 = _ref.buttonValue2,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      onClick = _ref.onClick,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["buttonLabel1", "buttonLabel2", "buttonValue1", "buttonValue2", "className", "dataTestId", "onClick", "value"]);

  return /*#__PURE__*/_react.default.createElement(_ToggleButtons.StyledToggleButtons, _extends({
    className: className,
    "data-test-id": dataTestId
  }, props), /*#__PURE__*/_react.default.createElement(_ToggleButtons.LeftButton, {
    className: value === buttonValue1 ? 'c-toggle-buttons-active' : '',
    colorTheme: value === buttonValue1 ? 'primary' : 'primaryGhost',
    dataTestId: "toggle-buttons-button1",
    onClick: onClick,
    value: buttonValue1
  }, buttonLabel1), /*#__PURE__*/_react.default.createElement(_ToggleButtons.RightButton, {
    className: value === buttonValue2 ? 'c-toggle-buttons-active' : '',
    colorTheme: value === buttonValue2 ? 'primary' : 'primaryGhost',
    dataTestId: "toggle-buttons-button2",
    onClick: onClick,
    value: buttonValue2
  }, buttonLabel2));
};

ToggleButtons.propTypes = {
  /** Label of first button */
  buttonLabel1: _propTypes.default.string.isRequired,

  /** Label of second button */
  buttonLabel2: _propTypes.default.string.isRequired,

  /** Value of first button */
  buttonValue1: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,

  /** Value of second button */
  buttonValue2: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Function to invoke upon being clicked */
  onClick: _propTypes.default.func.isRequired,

  /** Currently active value - you should provide this to tell the control which option to select by default */
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
};
ToggleButtons.defaultProps = {
  className: ''
};
var _default = ToggleButtons;
exports.default = _default;